import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

/**
 * Piccolo pulsante 📋 da posizionare accanto a un campo (Targa, Codice Fiscale, P.IVA, ecc.).
 * Mostra ✓ verde per 1.5s dopo la copia.
 *
 * Props:
 *  - value: stringa da copiare. Se vuota/null il pulsante è disabilitato.
 *  - label: etichetta del campo (per il toast: "{label} copiato").
 *  - testid: opzionale per i test automatici.
 *  - className: classi aggiuntive.
 *  - size: "sm" (default) | "md".
 */
export const CopyButton = ({ value, label = "Valore", testid, className = "", size = "sm" }) => {
  const [copied, setCopied] = useState(false);
  const disabled = !value || !String(value).trim();
  const dims = size === "md" ? "h-8 w-8" : "h-7 w-7";
  const icon = size === "md" ? "h-4 w-4" : "h-3.5 w-3.5";
  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (disabled) return;
    try {
      await navigator.clipboard.writeText(String(value).trim());
      setCopied(true);
      toast.success(`${label} copiato`);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Impossibile copiare negli appunti");
    }
  };
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      data-testid={testid}
      title={disabled ? "Niente da copiare" : `Copia ${label}`}
      className={`${dims} inline-flex items-center justify-center rounded-md border ${
        copied
          ? "border-emerald-300 bg-emerald-50 text-emerald-700"
          : "border-slate-300 bg-white text-slate-600 hover:bg-slate-100 hover:text-slate-900"
      } disabled:opacity-40 disabled:cursor-not-allowed transition-colors ${className}`}
    >
      {copied ? <Check className={icon} /> : <Copy className={icon} />}
    </button>
  );
};

export default CopyButton;
